import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideSlidersHorizontal = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 5H3m9 14H3M14 3v4m2 10v4m5-9h-9m9 7h-5m5-14h-7m-6 5v4m0-2H3"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideSlidersHorizontal);
const Memo = memo(ForwardRef);
export default Memo;
